import React, { useEffect, useState } from "react";
import { Modal, Switch, Form, message, Button } from "antd";
import { getNotificationSettings, updateNotificationSettings } from '../../api/api';

type Props = {
  open: boolean;
  onClose: () => void;
};

export const NotificationSettingsModal: React.FC<Props> = ({ open, onClose }) => {
  const [settings, setSettings] = useState({ email: true, inApp: true });
  const [originalSettings, setOriginalSettings] = useState(settings);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      getNotificationSettings().then(data => {
        setSettings(data);
        setOriginalSettings(data);
      });
    }
  }, [open]);

  const onChange = (changed: any) => {
    setSettings(prev => ({ ...prev, ...changed }));
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const updated = await updateNotificationSettings(settings);
      setSettings(updated);
      setOriginalSettings(updated);
      message.success("Settings updated");
      onClose();
    } catch (err) {
      message.error("Failed to update settings");
    }
    setLoading(false);
  };

  const handleCancel = () => {
    setSettings(originalSettings);
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      title="Notification Settings"
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button key="save" type="primary" loading={loading} onClick={handleSave}>
          Save
        </Button>
      ]}
    >
      <Form layout="vertical">
        <Form.Item label="In-app notifications">
          <Switch checked={settings.inApp} onChange={val => onChange({ inApp: val })} />
        </Form.Item>
        <Form.Item label="Email notifications">
          <Switch checked={settings.email} onChange={val => onChange({ email: val })} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
